function InputNotifier(options) {
	$.extend(this, options);
	this._init();
}

InputNotifier.prototype = {
	Id: null,
	WhileTyping: false,
	NotifyBlur: false,
	NotifyEveryBlur: false,
	NotifyForeignChanges: false,
	Notifier: undefined,

	timer: undefined,
	lastValue: '',
	hasFocus: false,

	$: function () {
		return $(`#${this.Id}`);
	},
	_init: function () {
		this.$().on('focus', () => this._focus());
		this.$().on('blur', () => this._blur());
		this.lastValue = this.$().val();
		if (this.NotifyForeignChanges) {
			this.timer = setInterval($.proxy(this._checkTimer, this), 200);
		}
	},
	_focus: function () {
		this.hasFocus = true;
		if (this.WhileTyping && !this.NotifyForeignChanges) {
			this.timer = setInterval($.proxy(this._checkTimer, this), 200);
		}
	},
	_blur: function () {
		if (!this.NotifyForeignChanges) {
			clearInterval(this.timer);
		}
		this._execNotifier(true);
		this.hasFocus = false;
	},
	_execNotifier: function (fromBlur) {
		if (!this.Notifier) {
			return false;
		}

		if (
			(fromBlur && this.NotifyEveryBlur) ||
			(this.userHasTyped() && fromBlur && this.NotifyBlur) ||
			(this.userHasTyped() && this.hasFocus && this.WhileTyping) ||
			(this.userHasTyped() && !this.hasFocus && this.NotifyForeignChanges)
		) {
			this.Notifier(this.userHasTyped(), this, fromBlur);
			return true;
		}
		return false;
	},
	_checkTimer: function () {
		this._execNotifier(false);
	},
	userHasTyped: function () {
		const wert = this.$().val();
		return this.lastValue !== wert;
	},
	clearUserHasTyped: function () {
		this.lastValue = this.$().val();
	},
	val: function (value) {
		if (value !== undefined) {
			if (value === null) {
				value = '';
			}
			const ret = this.$().valEx !== undefined ? this.$().valEx(value) : this.$().val(value);
			if (this.WhileTyping && this.lastValue !== value) {
				this.lastValue = value;
				if (this.Notifier) {
					this.Notifier();
				}
				const self = this;
				if (this.$().valid !== undefined) {
					window.setTimeout(function () {
						self.$().valid();
					}, 100);
				}
			} else {
				this.lastValue = value;
			}
			this.$().triggerHandler('change');
			return ret;
		}
		value = this.$().val();
		this.lastValue = value;
		return value;
	},
	trimmedVal: function () {
		const val = this.val();
		const trimmed = val != null ? val.replace(/\s*/g, '') : '';
		return trimmed === '' ? undefined : trimmed;
	},
	setValIfFieldIsEmpty: function (value) {
		if (value && this.val() === '') {
			this.val(value);
			return true;
		}
		return false;
	},
	attach: function (notifier) {
		this.Notifier = notifier;
	},
};
